<template>
  <div>
    <div v-if="items.length > 0 || text_to_filter !== null"
         class="row ml-3 mr-3">
      <div class="col-md-10">
        <slot name="table-data-filters">
          <b-form
              v-if="!disableFilter"
              @submit="e=>{e.preventDefault();load({page: 1, per_page: paginator.per_page}, this.order_by, this.order_desc)}"
              class="row"
              inline
          >
            <b-input-group class="rounded-20 border w-25 mb-2 bg-white-50">
              <b-dropdown id="table-filter" :text="field_to_filter.text" size="sm" variant="link pr-0">
                <b-dropdown-item v-for="field in fields_filter_local" :value="field.value"
                                 @click="field_to_filter = field">
                  {{ field.text }}
                </b-dropdown-item>
              </b-dropdown>
              <b-input id="input-filter" class="border-0 shadow-none bg-transparent" v-model="text_to_filter"/>
              <b-button id="btn-filter" variant="link" type="submit" class="align-self-center" pill>
                <i class="fas fa-search"/>
              </b-button>
            </b-input-group>
          </b-form>
        </slot>
      </div>
      <b-dropdown
          v-if="items.length > 0"
          :text="$t('components.table_data.gerenciar_colunas')"
          id="manage-columns"
          class="col-md-2"
          variant="link"
          block
          no-caret>
        <b-dropdown-form>
          <b-form-checkbox v-model="allSelected" @change="toggleAll">
            {{
              allSelected ? $t('components.table_data.desmarcar_todas') :
                  $t('components.table_data.selecionar_todas')
            }}
          </b-form-checkbox>
          <b-form-checkbox-group v-model="selected" :options="fields_checkbox" stacked/>
        </b-dropdown-form>
      </b-dropdown>
    </div>
    <TableSimple
        :items="items"
        :loading="loading"
        :selectable="selectable"
        :paginator="paginator"
        :fields="fieldsToShow"
        :text-empty="textEmpty"
        :route-new="routeNew"
        :text-new="textNew"
        @paginate="evt => load(evt, this.order_by, this.order_desc)"
        @sort-changed="evt => load(evt, this.order_by, this.order_desc)"
        @select="evt => $emit('select', evt)">
      <template v-for="slotName in Object.keys($scopedSlots)" v-slot:[slotName]="slotScope">
        <slot :name="slotName" v-bind="slotScope"/>
      </template>
    </TableSimple>
  </div>
</template>

<script>
import TableSimple from "@/components/TableSimple";

export default {
  name: "TableData",
  components: {TableSimple},
  props: {
    disableFilter: {
      type: Boolean,
      default: false
    },
    fieldsFilter: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    initial: {
      type: Array,
      default: () => []
    },

    /* Props TableSimple */
    textEmpty: {
      type: String
    },
    items: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    selectable: {
      type: Boolean
    },
    paginator: {
      type: Object
    },
    routeNew: {
      type: String
    },
    textNew: {
      type: String
    }
    /* END Props TableSimple */
  },
  computed: {
    fieldsToShow() {
      if (this.selected.length === 0) {
        return this.fields.filter(field => {
          return this.initial_local.includes(field.key)
        })
      }
      return this.fields.filter(field => {
        return this.selected.includes(field.key)
      })
    }
  },
  data() {
    return {
      selected: [],
      fields_filter_local: [],
      field_to_filter: {text: null, value: null},
      text_to_filter: null,
      order_by: "",
      order_desc: false,
      fields_checkbox: [],
      initial_local: [],
      allSelected: false,
    }
  },
  methods: {
    toggleAll(checked) {
      this.selected = checked ?
          this.fields_checkbox.map(f => {
            return f.value
          }).slice() :
          this.initial_local
    },
    load(evt, order_by = '', order_desc = false) {      
      const pagination = evt.per_page ? evt : {page: this.paginator.page, per_page: this.paginator.per_page}

      this.order_by = order_by
      this.order_desc = order_desc

      if (evt.hasOwnProperty('sortBy') && evt.sortBy !== '') {
        this.order_by = evt.sortBy
        this.order_desc = evt.sortDesc

        let fieldSorted = this.fieldsToShow.filter(field => {
          return field.key === evt.sortBy;
        });
        
        if (fieldSorted.length > 0  && fieldSorted[0].hasOwnProperty('keyFullName')) {
          this.order_by = fieldSorted[0].keyFullName
        }
      }

      const order = this.order_by !== '' ? {order_by: this.order_by, order_desc: this.order_desc} : null

      let filter = null
      if (this.text_to_filter && this.text_to_filter !== '') {
        filter = {filters: [[this.field_to_filter.value, 'LIKE', `%${this.text_to_filter}%`]]}
      }

      this.$emit('list', {...pagination, ...order, ...filter})
    }
  },
  mounted() {
    this.initial_local = this.initial
    this.selected = this.initial_local
    this.fields_checkbox = this.fields.map(f => {
      return {
        text: f.label,
        value: f.key
      }
    })

    this.fields_filter_local = this.fields_checkbox.filter(f => f.value !== 'status' && f.value !== 'id')
    if (this.fieldsFilter.length > 0) {
      this.fields_filter_local = this.fieldsFilter.map(f => {
        return {
          text: f.label,
          value: f.key
        }
      })
    }
    this.field_to_filter = this.fields_filter_local[0]

    if (this.initial_local.length === 0) {
      this.allSelected = true
      this.initial_local = [this.fields[0].key]
      this.selected = this.fields.map(f => {
        return f.key
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .dropdown-menu {
  transform: initial !important;
}

.w-25 {
  @media only screen and(max-width: 768px) {
    width: 100% !important;
  }
}

.rounded-20 {
  border-radius: 20px !important;
}

.bg-white-50 {
  background-color: rgba(255, 255, 255, 0.5);
}
</style>
